/* @flow */

import formSerialize from 'form-serialize';
import getInputPorId from '../../utils/get-input-por-id';
import { type Recurso } from '../../empresa/types';
import getElementoPorId from '../../utils/get-elemento-por-id';
import api from '../../utils/api';
import exibirErro from '../../utils/exibir-erro';

const preencherFormularioRecursos = (recursos: Recurso[]) => {
    recursos.forEach((recurso) => {
        getInputPorId(`recurso-${recurso}`).checked = true;
    });
};

const getRecursosFormulario = (): Recurso[] => (
    formSerialize(document.forms.namedItem('formulario-recursos'), { hash: true }).recursos
);

const setOnSubmitRecursos = (empresasId: number, esconderEditar: Function) => {
    const form = getElementoPorId('formulario-recursos');
    form.onsubmit = (e) => {
        e.preventDefault();
        api.cadastrarRecursosPorEmpresasId(empresasId, getRecursosFormulario())
            .then(esconderEditar)
            .catch(exibirErro);
    };
};

export {
    preencherFormularioRecursos,
    setOnSubmitRecursos,
};
